import { StyleSheet, Platform } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { getWindowDimensions } from '../Utils/Helpers';

const paddingBottom = Platform.select({
  ios: 106,
  android: 130,
});

export default StyleSheet.create({
  containerStyle: withTray => ({
    flex: 1,
    paddingBottom: withTray ? paddingBottom : 16,
  }),
  fullLoadingContainer: {
    paddingHorizontal: 16,
  },
  titleContainerStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16.7,
    ...Platform.select({
      ios: { marginTop: getWindowDimensions.height < 800 ? 12 : 25 },
      android: { marginTop: 16 },
    }),
  },
  titleTextStyle: {
    ...Fonts.type.bold,
    fontSize: 25,
  },
  subTitleContainerStyle: {
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  subTitleTextStyle: {
    marginHorizontal: 9,
    color: Colors.vfRed,
    fontSize: 16.6,
    marginVertical: 4,
  },
  descriptionTextStyle: {
    fontSize: 16.6,
    color: Colors.smoothGrey,
    marginBottom: 23.6,
  },
  filterBarContainerStyle: {
    paddingLeft: 0,
    marginBottom: 18,
    paddingEnd: 16,
  },
  itemTextStyle: { textTransform: 'none' },
  categoriesErrorIconStyle: { marginTop: 50 },
  usersErrorIconStyle: { marginTop: 0 },
  errorScreenBackgroundStyle: { height: 400 },
  containerWithPadding: {
    paddingHorizontal: 16,
  },
});
